import { MuiMaterials } from "../../@index.js";
import { getWindowChromeThemeColor } from "./windowChromeTheme.js";
import { BRAND_GOLD } from "./brandGold.js";
import { outlinedActionButtonSx } from "./actionButtons.js";

/** Backdrop tint used by Start Scan and matching confirm dialogs. */
export function confirmDialogBackdropSx() {
    return {
        backgroundColor: getWindowChromeThemeColor(
            "rgba(255, 255, 255, 0.45)",
            "rgba(0, 0, 0, 0.45)",
        ),
    };
}

/** Centered panel matching Start Scan confirmation. */
export function confirmDialogPaperSx() {
    return {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: getWindowChromeThemeColor("#ffffff", "#2d2d2d"),
        border: "none",
        boxShadow: "none",
        p: 4,
        outline: "none",
        borderRadius: 1,
        color: getWindowChromeThemeColor("#333333", BRAND_GOLD),
    };
}

/** Inline card variant (e.g. site select phase) — same look, not absolutely centered. */
export function confirmDialogCardSx() {
    return {
        width: "min(420px, 92vw)",
        bgcolor: getWindowChromeThemeColor("#ffffff", "#2d2d2d"),
        border: "none",
        boxShadow: "none",
        backgroundImage: "none",
        p: 4,
        outline: "none",
        borderRadius: 1,
        color: getWindowChromeThemeColor("#333333", BRAND_GOLD),
    };
}

export function confirmDialogTitleSx() {
    return {
        color: getWindowChromeThemeColor("#333333", BRAND_GOLD),
    };
}

export function confirmDialogActionsSx() {
    return {
        margin: "22px auto -13px auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap",
    };
}

/** Confirm actions use Comparison outlined button style. */
export function confirmDialogButtonSx() {
    return {
        ...outlinedActionButtonSx(),
        size: undefined,
        margin: "2px",
        cursor: "pointer",
        "& > *": {
            pointerEvents: "none",
        },
    };
}

/**
 * Start Scan–style confirmation modal.
 *
 * @param {{
 *   open: boolean,
 *   onClose: Function,
 *   title: React.ReactNode,
 *   titleId?: string,
 *   children?: React.ReactNode,
 *   actions: React.ReactNode,
 * }} props
 */
export default function ConfirmDialog({
    open,
    onClose,
    title,
    titleId = "confirm-dialog-title",
    message = null,
    children = null,
    actions,
    /** Extra props for Modal (e.g. disablePortal / container). */
    modalProps = null,
}) {
    return (
        <MuiMaterials.Modal
            open={!!open}
            onClose={onClose}
            aria-labelledby={titleId}
            sx={confirmDialogBackdropSx()}
            {...(modalProps || {})}
        >
            <MuiMaterials.Box sx={confirmDialogPaperSx()}>
                <MuiMaterials.Typography
                    id={titleId}
                    variant="h6"
                    component="h2"
                    sx={confirmDialogTitleSx()}
                >
                    {title}
                </MuiMaterials.Typography>
                {message ? (
                    <MuiMaterials.Typography
                        variant="body2"
                        sx={{
                            mt: 1,
                            color: getWindowChromeThemeColor("#444444", "#c4a574"),
                        }}
                    >
                        {message}
                    </MuiMaterials.Typography>
                ) : null}
                {children}
                <div style={confirmDialogActionsSx()}>
                    {actions}
                </div>
            </MuiMaterials.Box>
        </MuiMaterials.Modal>
    );
}
